import React from 'react'
import ShowComment from './CommentSection'
import MrpProofUpload from './mrpProofUpload'
import CommissionInfo from './CommisionInfo'


export default function useUploadPhotoProof(mrp_inventory, onUpload = (...e) => console.log("batch_proof", e), ModifiedMRPModalIndexes, isImageProofsError) {

   

    const getCommissionInfo = (commission_value) => {
        if (!mrp_inventory) return <></>
        return <CommissionInfo commission_value={commission_value} />
    }

    const getComment = (mrp_status, rejected_reason) => {
        if(!mrp_inventory) return <></>;
        return <ShowComment mrp_status={mrp_status} mrp_rejected_reason={rejected_reason} />
    }

    const getUpload = (cur_batch) => {
        if (!mrp_inventory) return <></>
        let _imageProofError=isImageProofsError;
        if(ModifiedMRPModalIndexes){
            const errObj=cur_batch?.errorObj || cur_batch;
            if(errObj?.uploadProductFrontImageError){
                _imageProofError=errObj?.uploadProductFrontImageError;
            } else if(errObj?.uploadImageError){
                _imageProofError=errObj?.uploadImageError
            }
        }
        // _imageProofError=ModifiedMRPModalIndexes ? cur_batch.errorObj?.isImageProofsError: isImageProofsError
        // console.log("_imageProofError",_imageProofError)

        return <MrpProofUpload onUpload={onUpload} cur_batch={cur_batch} imageProofsError1={_imageProofError?.length>0?_imageProofError[0]:null} imageProofsError2={_imageProofError?.length>1?_imageProofError[1]:null} />
    }



    const getBothCommentAndUpload = (cur_batch) => { //cur_batch could be productData incase of single Batch

        // console.log("getBothCommentAndUpload",cur_batch,mrp_inventory)
        // if (ModifiedMRPModalIndexes && ModifiedMRPModalIndexes.indexOf(cur_batch.index) == -1) {
        //     return <div className={`${styles["upload_photo_proof"]}`}>
        //         {getCommissionInfo(cur_batch?.commission_value)}
        //     </div>
        // }
        if (!mrp_inventory) {
            return <></>
        }
        return (
            <div>
                {
                    ModifiedMRPModalIndexes && getCommissionInfo(cur_batch?.commission_value)
                }
                {/* {getComment(cur_batch?.mrp_status, cur_batch.mrp_rejected_reason)} */}
                {getUpload(cur_batch)}
            </div>
        )
    }

    return { getCommissionInfo, getComment, getUpload, getBothCommentAndUpload }
}
